import { Pagination } from "antd";
import React from "react";
import MobilePagination from "./MobilePagination";

const SinglePagination = ({
  dimensions=770,
  current=1,
  total=0,
  onChange=() => {},
  pageSize = 20,
  ...props
}) => {
  return dimensions > 769 ? (
    <Pagination
      total={total}
      current={current}
      defaultPageSize={pageSize}
      onChange={(page, pageSize) => onChange(page, pageSize)}
      {...props}
    />
  ) : (
    <MobilePagination
      total={total}
      current={current}
      defaultPageSize={pageSize}
      onChange={(page) => onChange(page, pageSize)}
      {...props}
    />
  );
};

export default SinglePagination;
